const ar = {
	login: 'تسجيل الدخول',
	logout: 'تسجيل خروج',
	signin: 'تسجيل الدخول',
	signup: 'سجل',
	email: 'البريد الإلكتروني',
	emailAddr: 'عنوان البريد الإلكتروني',
	password: 'كلمه السر',
	rememberMe: 'تذكرنى',
	forgotYourPwd: 'نسيت رقمك السري؟',
	signinFacebook: 'قم بتسجيل الدخول باستخدام الفيسبوك',
	signinGoogle: 'الدخول مع جوجل',
	dontAccount: 'لا تملك حساب؟',
	firstName: 'الاسم الاول',
	lastName: 'الكنية',
	confirmPwd: 'تأكيد كلمة المرور',
	signup_msg: 'بالنقر فوق الانضمام الآن ، فإنك توافق على',
	digitX_user_agreement: 'اتفاقية مستخدم DigitXchange',
	privacy_policy: 'سياسة خاصة',
	and: ' و',
	cookies_policy: 'اتفاقية ملفات تعريف الارتباط',
	have_account: 'هل لديك حساب',
	forgotPwd: 'نسيت كلمة المرور',
	recoverPwd: 'إستعادة كلمة المرور',
	forgotPwd_msg: 'ضع بريدك الإلكتروني في الحقل أعلاه ، وسوف نرسل لك رابطًا مع التعليمات التي يجب اتباعها.',
	changePwd: 'تغيير كلمة السر',
	oldPwd: 'كلمة المرور القديمة',
	newPwd: 'كلمة مرور جديدة',
	confirmNewPwd: 'تأكيد كلمة المرور الجديدة',
	user_account: 'حساب المستخدم',
	change_pic: 'تغيير الصورة',
	mobile_number: 'رقم الهاتف المحمول',
	country: 'بلد',
	update_settings: 'إعدادات التحديث',
	company: 'شركة',
	aboutUs: 'معلومات عنا',
	tos: 'شروط الخدمة',
	copyright: 'حقوق النشر',
	socialMedia: 'وسائل التواصل الاجتماعي',
	forUpdates: 'للحصول على التحديثات',
	footer_msg_1: 'بالتسجيل أنت تقبل الخروج',
	terms: 'شروط الخدمة',
	contactUs: 'اتصل بنا',
	yourEmail: 'بريدك الالكتروني',
	required: 'مطلوب',
	yourMsg: 'رسالتك',
	sent: 'أرسلت',
	footer_msg_2: 'جميع الحقوق محفوظة',
	footer_msg_3: 'جميع أسماء المنتجات والعلامات التجارية والعلامات التجارية المسجلة هي ملك لأصحابها',
	doom: 'الموت الثالث',
	filter: 'منقي',
	add_asset: 'إضافة أصل',
	request_game: 'طلب لعبة',
	search_msg: 'عذرا ، ولكن لا شيء يطابق شروط البحث الخاصة بك.',
	post: 'بريد',
	asset: 'الأصل',
	create: 'خلق',
	character: 'حرف',
	characters: 'الشخصيات',
	assets: 'الأصول',
	profile: 'الملف الشخصي',
	game: 'لعبه',
	games: 'ألعاب',
	currency: 'عملة',
	store: 'متجر',
	all_time: 'كل الوقت',
	this_month: 'هذا الشهر',
	trending: 'الشائع',
	item_name: 'اسم العنصر',
	view_item: 'عرض العنصر',
	leaderboard: 'المتصدرين',
	posters: 'ملصقات',
	chinese: 'صينى',
	english: 'الإنجليزية',
	japanese: 'اليابانية',
	korean: 'الكورية',
	german: 'ألمانية',
	french: 'فرنسي',
	spanish: 'الأسبانية',
	italian: 'إيطالي',
	russian: 'الروسية',
	portuguese: 'البرتغالية',
	hindi: 'هندي',
	arabic: 'عربى',
	buy: 'يشترى',
	subscription: 'اشتراك',
	buy_subscription: 'شراء اشتراك',
	gift: 'هدية مجانية',
	xchange: 'Xchange',
	subscription_plan: 'خطة الاشتراك',
	payment_options: 'خيارات الدفع',
	cardholder_name: 'إسم صاحب البطاقة',
	submit_order: 'أكد الطلب',
	card_number: 'رقم البطاقة',
	cvv: 'CVV',
	expiration_date: 'تاريخ إنتهاء الصلاحية',
	buyXchange: 'شراء Xchange',
	giftXchange: 'تبادل الهدايا',
	or: 'أو',
	select: 'تحديد',

		search: 'بحث',
	search_games: 'بحث في الألعاب ...',
	search_assets: 'بحث الأصول ...',
	platform: 'منصة',
	total_posts: 'إجمالي المشاركات',
	total_comments: 'مجموع التعليقات',
	total_characters: 'إجمالي الأحرف',
	total_assets: 'إجمالي الأصول',
	xchange_currency: 'عملة Xchange',
	subscription_days_remaining: 'أيام الاشتراك المتبقية',
	total_asset_networth: 'إجمالي الأصول نتورث',
	total_character_networth: 'إجمالي الأحرف Networth',
	most_downloaded: 'الأكثر تحميلا',
	recently_added: 'أضيف مؤخرا',
	genre: 'النوع',
	my_library: 'مكتبتي',
	most_commented: 'الأكثر تعليقا',
	most_recent: 'الأحدث',
	nearing_addition: 'على وشك الإضافة',
	create_asset: 'إنشاء الأصول',
	create_character: 'إنشاء إختصار',
	asset_name: 'اسم الأصل',
	asset_type: 'نوع الأصول',
	rarity: 'ندرة',
	enhancements: 'التحسينات',
	add: 'أضف',
	currency_type: 'نوع العملة',
	price: 'السعر',
	description: 'وصف',
	upload_asset: 'تحميل الأصول',
	preview_asset: 'معاينة الأصول',
	main_image: 'الصورة الرئيسية',
	upload_video: 'رفع فيديو',
	upload: 'رفع',
	view_demo: 'عرض تجريبي',
	character_name: 'اسم الشخصية',
	character_type: 'نوع الحرف',
	upload_character: 'تحميل حرف',
	preview_character: 'شخصية المعاينة',
	race: 'سباق',
	class: 'صف دراسي',
	gender: 'جنس',
	level: 'مستوى',
	showing: 'عرض',
	of: 'من',
	results: 'النتائج',
	featured_characters: 'الشخصيات البارزة',
	url: 'URL',
	submit: 'إرسال',
	real_world: 'العالم الحقيقي',
	game_currency: 'عملة اللعبة',
	all: 'الكل',

	edit: 'تعديل',
	save: 'حفظ',
	agg_character_networth: 'تجميع الأحرف Networth',
	agg_time_played: 'مجموع وقت اللعب',
	agg_asset_value: 'قيمة الأصول المجمعة',
	enter_character_creation_date: 'أدخل تاريخ إنشاء الأحرف',
	in_game_currency: 'بعملة اللعبة',
	real_world_value: 'القيمة العالمية الحقيقية',
	update_character: 'تحديث الحرف',
	item_not_found: 'العنصر غير موجود!',
	ripper: 'الممزق',
	comments: 'تعليقات',
	add_comments: 'أضف تعليقات',
	new_suggested_price: 'السعر المقترح الجديد',
	sort_by: 'صنف حسب',
	reply: 'الرد',
	asset_networth: 'الأصول نتورث',
	join_date: 'تاريخ الانضمام',
	report: 'نقل',
	first: 'أول',
	last: 'الاخير',
	most_replies: 'معظم الردود',
	new_pricing_recommendations: 'توصيات التسعير الجديدة',
	xchange_amount: 'مبلغ Xchange',
	username: 'اسم المستخدم',
	send_gift: 'أرسل هدية',
	message: 'رسالة',
	gift_text: 'تخصيص رسالتك هنا',
	day: 'وم',
	days: 'أيام',
	currency_converter: 'محول العملات',
	from: 'من عند',
	to: 'إلى',
	in_game: 'في اللعبة',
	real_life: 'الحياه الحقيقيه',
	cvc: 'رمز التحقق من البطاقة',
	card: 'بطاقة',
	per_month: 'شهريًا (3 دولارات شهريًا)',
	per_year: 'سنوي (30 دولارًا سنويًا)',
	aboutUs_text: 'DigitXChange هو موقع إلكتروني موجه للمجتمع يهدف في النهاية إلى وضع قيمة لقيمة السلع والخدمات الرقمية عبر الاستعانة بمصادر خارجية. إذا كنت قد سألت يومًا سؤال "ما قيمة شخصيتي فعليًا" أو "أتساءل ما هي التجارة العادلة مع لاعب آخر في لعبة أخرى" ، فلا تبحث عن مزيد من الإجابات. نأمل أن تستمتع بموقعنا ، وتشارك في بناء المعرفة الجماعية ، وإظهار الغنائم التي حصلت عليها بشق الأنفس ، ونتطلع في نهاية المطاف إلى معرفة إجمالي صافي ثروتك الرقمية!',
	home: 'الصفحة الرئيسية',
	all_time_characters: 'جميع الشخصيات الوقت',
	this_month_characters: 'شخصيات هذا الشهر',
	trending_characters: 'تتجه الشخصيات',
	all_time_posters: 'جميع ملصقات الوقت',
	this_month_posters: 'ملصقات هذا الشهر',
	trending_posters: 'ملصقات شائعة',
	
};

export default ar;


// WEBPACK FOOTER //
// ./src/translations/ar.js